<template>
    <div>
        <h1>Welcome to admin system</h1>
    </div>
</template>

<script>
    export default {
        name: 'Welcome',
        components: {},
        props: {},
        data() {
            return {};
        },
        computed: {},
        created() {},
        mounted() {},
        methods: {},
        watch: {},
    };
</script>

<style scoped></style>
